import { Button, Flex, LabelForm, Text, Title } from '@collable/ui'
import styled from '@emotion/styled'
import { usePostChannelOwnership } from '@/api/channel'
import { useMemo, useState } from 'react'
import { emailRegex, urlRegex } from '@/utils/regex'

interface VerifyChannelPostEmailProps {
  setOwnershipRequestId: (ownershipRequestId: number) => void
}

const VerifyChannelPostEmail = ({ setOwnershipRequestId }: VerifyChannelPostEmailProps) => {
  const [channelInfo, setChannelInfo] = useState<{
    channelUrl: string
    email: string
  }>({
    channelUrl: '',
    email: '',
  })

  const { mutate: postChannelOwnership } = usePostChannelOwnership()

  const disabled = useMemo(() => {
    return (
      !channelInfo.channelUrl ||
      !channelInfo.email ||
      !urlRegex.test(channelInfo.channelUrl) ||
      !emailRegex.test(channelInfo.email)
    )
  }, [channelInfo])

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    postChannelOwnership(channelInfo, {
      onSuccess: res => {
        setOwnershipRequestId(res.ownershipRequestId)
      },
    })
  }

  return (
    <Content direction="column" gap={40} as="form" onSubmit={onSubmit}>
      <Flex direction="column" gap={8}>
        <Title size="title2" fontWeight="bold" color="labelStrong" as="h2">
          채널 소유권 신청하기
        </Title>
        <Text size="body2" color="labelAlternative">
          유튜브 채널에 기재된 이메일이 본인 이메일인지 확인해요
        </Text>
      </Flex>
      <Flex direction="column" gap={20}>
        <LabelForm
          type="url"
          required
          label="유튜브 채널 주소"
          placeholder="유튜브 → 내 채널 URL 복사"
          size="large"
          value={channelInfo.channelUrl}
          width="100%"
          onChange={e => setChannelInfo({ ...channelInfo, channelUrl: e.target.value })}
        />
        <LabelForm
          type="email"
          required
          label="이메일"
          placeholder="유튜브 채널 설명란에 기재된 이메일 주소"
          size="large"
          value={channelInfo.email}
          width="100%"
          onChange={e => setChannelInfo({ ...channelInfo, email: e.target.value })}
        />
      </Flex>
      <Button
        width="100"
        color="primary"
        kind="solid"
        size="large"
        disabled={disabled}
        type="submit"
      >
        채널 소유권 신청하기
      </Button>
    </Content>
  )
}

export default VerifyChannelPostEmail

const Content = styled(Flex)`
  width: 600px;
  border-radius: 20px;
  padding: 28px;
  background-color: ${({ theme }) => theme.common.commonWhite};
`
